var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentKey,{ref:"dialog",tag:"component",attrs:{"his-information":_vm.hisInformation,"parameter":_vm.parameter,"selected-items":_vm.selectedItems,"editing-document":_vm.editingDocument}})}
var staticRenderFns = []

export { render, staticRenderFns }